// Imports
import plugin0 from '/Users/ragusiva/Programming/JavaScript/Jam3-Projects/nyg-static-jam3/test/static-test/static-3/node_modules/react-static-plugin-react-router/browser.api.js'

// Plugins
const plugins = [{
  location: "/Users/ragusiva/Programming/JavaScript/Jam3-Projects/nyg-static-jam3/test/static-test/static-3/node_modules/react-static-plugin-react-router",
  plugins: [],
  hooks: plugin0({})
},
{
  location: "/Users/ragusiva/Programming/JavaScript/Jam3-Projects/nyg-static-jam3/test/static-test/static-3",
  plugins: [],
  hooks: {}
}]

// Export em!
export default plugins